import React from "react";
import styles from "../../../assets/css/modules/containers/toggle-drawer.css";
import propTimer from "../../../components/shared/PropTimer";
import { compose } from "redux";

export class ToggleDrawer extends React.Component {
  drawerRef = React.createRef();

  render() {
    let targetHeight =
      (this.drawerRef.current && this.drawerRef.current.scrollHeight) || 0;
    let width =
      (this.drawerRef.current && this.drawerRef.current.scrollWidth) || 0;
    let gradientClassName =
      this.props.gradientClass &&
      this.props.gradientClass + (this.props.bottom ? "bottom" : "top");
    let gradientClass = gradientClassName && styles[gradientClassName];

    return (
      <div
        className={styles.drawer}
        aria-hidden={this.props.isOpen ? false : true}
        style={{
          height:
            (this.props.isOpenChanging && targetHeight) ||
            (this.props.isOpen && "auto") ||
            0
        }}
        ref={this.drawerRef}
      >
        <div
          className={
            this.props.bottom
              ? styles.drawerInnerBefore
              : this.props.drawerInnerAfter
          }
          style={
            this.props.bottom && this.props.isOpen2Changing
              ? { position: "absolute", bottom: "0px", width: width }
              : undefined
          }
        >
          {this.props.children}
        </div>
        {this.props.bottom && this.props.isOpen2Changing ? (
          <div style={{ height: targetHeight }} />
        ) : null}
        <div
          className={
            (this.props.bottom ? styles.drawerBefore : styles.drawerAfter) +
            (gradientClass ? " " + gradientClass : "")
          }
        />
      </div>
    );
  }
}

const enhance = compose(
  propTimer("isOpen", [true, false], [600, 600], "isOpen2Changing"),
  propTimer("isOpen", [true, false], [600, 0])
);

export default enhance(ToggleDrawer);
